import { ApplicationSetting } from '@app/core/model/company.model'
import { ApplicationSettingApi } from '../models/application-setting-api.model'
import { ApplicationSettingsItem } from '../models/application-settings-item.model'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { RateCardMetaStructure } from '../models'
import { environment } from '@envs/environment'

@Injectable({ providedIn: 'root' })
export class ApplicationSettingsApiService {
  private readonly BASE_API_URL: string = environment.scopeApiUrl

  constructor(private http: HttpClient) {}

  getRateCardMetaStructure(): Observable<RateCardMetaStructure> {
    return this.http.get<RateCardMetaStructure>(`${this.BASE_API_URL}company/ratecard/meta-structure`)
  }

  saveRateCardMetaStructure(metaStructure: RateCardMetaStructure): Observable<RateCardMetaStructure> {
    return this.http.post<RateCardMetaStructure>(`${this.BASE_API_URL}company/ratecard/meta-structure`, metaStructure)
  }

  getApplicationSettings(): Observable<ApplicationSettingsItem[]> {
    return this.http.get<ApplicationSettingsItem[]>(`${this.BASE_API_URL}company/application-settings`)
  }

  updateApplicationSetting(setting: ApplicationSettingApi): Observable<ApplicationSetting[]> {
    return this.http.put<ApplicationSetting[]>(`${this.BASE_API_URL}company/setting`, setting)
  }

  clearTrafficImportCache() {
    return this.http.delete(`${this.BASE_API_URL}company/cache/traffic-system-import`)
  }
}
